module.exports = __webpack_public_path__ + "static/media/crocodile(12).348ff386.PNG";